import { render, staticRenderFns } from "./myService.vue?vue&type=template&id=30a543ee&scoped=true&"
import script from "./myService.vue?vue&type=script&lang=js&"
export * from "./myService.vue?vue&type=script&lang=js&"
import style0 from "./myService.vue?vue&type=style&index=0&id=30a543ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a543ee",
  null
  
)

component.options.__file = "myService.vue"
export default component.exports